export const getCategories = (state) => state.categories
export const getCategory = (state) => (hash_id) => { return state.categories.filter((category) => { return category.hash_id == hash_id })[0] }
export const getParentCategories = (state) => state.categories.filter(category => { return !category.parent_id})
